import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import RightArrowIcon from 'transfix-icons/build/RightArrowIcon'
import { makeStyles } from 'transfix-ui/core/styles'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks/useFMSAnalytics'
import { brandColors } from 'transfix-ui'
import { POPULAR_TOOLS_LINKS } from '../constants'

const usePopularToolsButtonsStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1.5),
    padding: `0px ${theme.spacing(2)}`,

    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: theme.spacing(1.5),
      padding: `0px`,
    },

    [theme.breakpoints.up('xl')]: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1.5),
    },
  },
  row: {
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
    },

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      gap: theme.spacing(3),
    },
  },
  column: {
    [theme.breakpoints.up('lg')]: {
      flexWrap: 'wrap',
    },
    [theme.breakpoints.up('xl')]: {
      flexDirection: 'column',
      flexWrap: 'no-wrap',
    },
  },
  spacer: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  buttonWrapper: {
    flex: '0 0 122px',

    [theme.breakpoints.up('xl')]: {
      flex: '1 1',
    },

    '& > a': {
      width: '100%',
      height: '100%',

      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    background: brandColors.white,
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${brandColors.coolGray2}`,

    '&:hover, &:focus': {
      background: brandColors.coolGray3,
      textDecoration: 'none',
    },

    [theme.breakpoints.up('lg')]: {
      gap: theme.spacing(2),
      padding: theme.spacing(2),
      height: 'auto',
    },

    [theme.breakpoints.up('xl')]: {
      background: brandColors.coolGray1,
      borderColor: 'transparent',
    },
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: brandColors.black,
    flexDirection: 'column',
    fontSize: theme.spacing(2),
    width: '100%',

    [theme.breakpoints.up('lg')]: {
      fontSize: theme.spacing(1.75),
      gap: theme.spacing(2),
      flexDirection: 'row',
      width: 'auto',
    },
  },
  icon: {
    width: theme.spacing(3),
    height: theme.spacing(3),

    [theme.breakpoints.up('lg')]: {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
    },
  },
  arrow: {
    display: 'none',

    [theme.breakpoints.up('lg')]: {
      display: 'block',
    },
  },
}))

export interface IPopularToolsButtonsProps {
  /**
   * @default true
   */
  displayInline?: boolean
}

const PopularToolsButtons = memo<IPopularToolsButtonsProps>(({ displayInline = true }) => {
  const classes = usePopularToolsButtonsStyles()
  const history = useHistory()
  const { trackEvent } = useFMSAnalytics()

  return (
    <div className={`${classes.root} ${displayInline ? classes.row : classes.column}`}>
      {POPULAR_TOOLS_LINKS.map(({ Icon, event, link, title }) => (
        <div key={title} className={classes.buttonWrapper}>
          <button
            className={classes.button}
            onClick={() => {
              trackEvent('Homepage', event)
              history.push(link)
            }}>
            <div className={classes.buttonContent}>
              <Icon size='large' className={classes.icon} />
              <div>{title}</div>
            </div>
            <RightArrowIcon size='large' color='coolGray5' className={classes.arrow} />
          </button>
        </div>
      ))}
      <div className={classes.spacer}>&nbsp;</div>
    </div>
  )
})

export default PopularToolsButtons
